export default __webpack_public_path__ + "static/media/checked-circle-green.89b8181a.svg";